var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuy5DaysHolidays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211.7 200",
    style: {
      enableBackground: "new 0 0 211.7 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.7,118.1l-10.2,10.2c-3.3,3.3-7.7,5.2-12.4,5.2s-9.1-1.9-12.2-5.2l-39.9-39.8v95.7 c0,9.8-8.2,15.9-17.4,15.9H97.1c-9.2,0-17.4-6.1-17.4-15.9V88.5l-39.9,39.8c-3.1,3.3-7.6,5.2-12.2,5.2s-9.1-1.9-12.2-5.2L5.2,118.1 c-3.3-3.3-5.2-7.6-5.2-12.2c0-4.6,1.9-9.1,5.2-12.4L93.6,5c3.1-3.3,7.6-5,12.2-5s9.1,1.8,12.4,5l88.5,88.5c3.1,3.3,5,7.7,5,12.4 C211.7,110.5,209.8,114.8,206.7,118.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy5DaysHolidays);
export default __webpack_public_path__ + "static/media/Buy_5_Days_Holidays.beda0015324596afe765871ecd60ef11.svg";
export { ForwardRef as ReactComponent };